import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Row.module.sass";
import cn from "classnames";
import moment from "moment";
import Barcode from "react-barcode";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import ReactDOM from "react-dom";
import Icon from "../../../../../../../components/Icon";

const Row = ({ 
  item, 
  activeTable, 
  activeId, 
  setActiveId,
  value,
  onChange 
}) => {
  const navigate = useNavigate();

  const handleUpdate = (barcode) => {
    setActiveId(barcode.id);
    navigate(`/settingsDashboard/camera&Barcode/actionBarcodesForCamera/${barcode.barcode_value}`, { 
      state: { barcode } 
    });
  };

  const handleDownload = async (event, barcode_value) => {
    event.stopPropagation();
    
    const hiddenDiv = document.createElement("div");
    hiddenDiv.style.position = "absolute";
    hiddenDiv.style.top = "-10000px";
    document.body.appendChild(hiddenDiv);

    const barcodeElement = document.createElement("div");
    hiddenDiv.appendChild(barcodeElement);

    const barcode = <Barcode value={barcode_value} />;
    ReactDOM.render(barcode, barcodeElement);

    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(barcodeElement);
    const barcodeImage = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    pdf.addImage(barcodeImage, "PNG", 30, 50, 150, 70);
    pdf.save(`barcode_${barcode_value}.pdf`);

    document.body.removeChild(hiddenDiv);
  };

  const cameraList = item.cameras
    .slice(0, 2)
    .map((camera) => `${camera.name} (${camera.mode})`)
    .join(", ");
  const moreCameras = item.cameras.length > 2 ? ` +more` : "";

  return (
    <div
      className={cn(
        styles.row,
        { [styles.selected]: activeId === item.id },
        { [styles.active]: activeTable }
      )}
      onClick={() => handleUpdate(item)}
    >
      <div className={styles.col}>
        <div className={styles.email}>{item.barcode_value}</div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {cameraList}
          {moreCameras}
        </div>
      </div>
      <div className={styles.col}>
        <div className={styles.email}>
          {moment(item.created_at).format("DD MMM YYYY")}
        </div>
      </div>
      <div className={styles.col}>
        <div
          onClick={(event) => handleDownload(event, item.barcode_value)}
          className={cn(styles.purchase, {
            "status-role-active": item.status === true,
            "status-role-inactive": item.status === false,
          })}
        >
          <Icon name="download" size="24" />
        </div>
      </div>
    </div>
  );
};

export default Row;
